import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Role } from "../../models/authorization";
import { RolePrivilegesDataService } from "../../services/administration/role-privileges.service";
import { IRolePrivilegesData } from "../../interfaces/administration/rolePrivilegesData";
import { UtcDatePipe } from "../../pipes/utc-date.pipe";
import { RolesPrivilegesSkeletonComponent } from "./roles-privileges-skeleton/roles-privileges-skeleton.component";
import { LeftMenuComponent } from "../../menu/left-menu/left-menu.component";

@Component({
  selector: "roles-privileges-component",
  templateUrl: "./roles-privileges.component.html",
  imports: [CommonModule, FormsModule, LeftMenuComponent, UtcDatePipe, RolesPrivilegesSkeletonComponent]
})
export class RolesPrivilegesComponent implements OnInit {
  // Available roles
  availableRoles: Role[] = [
    Role.Admin,
    Role.EnterpriseLead,
    Role.OperationsManager,
    Role.AMORETeam,
    Role.PlatformUser,
    //Role.TechnicalOwner
  ];

  selectedRole: Role | null = null;
  privileges: IRolePrivilegesData[] = [];
  originalPrivileges: IRolePrivilegesData[] = [];
  loading: boolean = false;
  saving: boolean = false;
  hasChanges: boolean = false;

  newPrivilege: {
    pageCategory: string;
    pageSubCategory: string;
    accessType: 'None' | 'Read' | 'Write';
  } = {
    pageCategory: '',
    pageSubCategory: '',
    accessType: 'Read'
  };

  constructor(
    private rolePrivilegesService: RolePrivilegesDataService
  ) { }

  ngOnInit(): void {
    // Component initialized
  }

  onRoleChange(): void {
    if (this.selectedRole) {
      this.loadPrivilegesForRole(this.selectedRole);
    } else {
      this.privileges = [];
      this.hasChanges = false;
    }
  }

  loadPrivilegesForRole(role: Role): void {
    this.loading = true;
    this.hasChanges = false;
    
    this.rolePrivilegesService.getRolePrivileges(role).subscribe({
      next: (data) => {
        this.privileges = [...data];
        this.originalPrivileges = JSON.parse(JSON.stringify(data)); // Deep copy
        this.loading = false;
      },
      error: (error) => {
        console.error('Error loading privileges:', error);
        this.privileges = [];
        this.loading = false;
        alert('Failed to load privileges for this role.');
      }
    });
  }

  addPrivilege(): void {
    if (!this.selectedRole || !this.newPrivilege.pageCategory || !this.newPrivilege.pageSubCategory) {
      return;
    }

    // Check if privilege already exists
    const exists = this.privileges.some(p => 
      p.pageCategory === this.newPrivilege.pageCategory &&
      p.pageSubCategory === this.newPrivilege.pageSubCategory
    );

    if (exists) {
      alert('A permission with this Page Category and Sub-Category already exists!');
      return;
    }

    // Create new privilege
    const newPriv: IRolePrivilegesData = {
      rpid: 0,
      userRole: this.selectedRole,
      pageCategory: this.newPrivilege.pageCategory,
      pageSubCategory: this.newPrivilege.pageSubCategory,
      accessType: this.newPrivilege.accessType,
      lastUpdatedBy: 'Current User',
      lastUpdatedDate: new Date()
    };

    this.privileges.push(newPriv);
    this.hasChanges = true;

    // Reset form
    this.newPrivilege = {
      pageCategory: '',
      pageSubCategory: '',
      accessType: 'Read'
    };
  }

  deletePrivilege(privilege: IRolePrivilegesData): void {
    if (confirm(`Are you sure you want to delete permission for ${privilege.pageCategory}.${privilege.pageSubCategory}?`)) {
      const index = this.privileges.indexOf(privilege);
      if (index > -1) {
        this.privileges.splice(index, 1);
        this.hasChanges = true;
      }
    }
  }

  saveChanges(): void {
    if (!this.selectedRole) {
      return;
    }

    this.saving = true;

    this.rolePrivilegesService.updateRolePrivileges(this.privileges).subscribe({
      next: () => {
        alert('Permissions saved successfully!');
        this.hasChanges = false;
        this.originalPrivileges = JSON.parse(JSON.stringify(this.privileges));
        this.saving = false;
      },
      error: (error) => {
        console.error('Error saving privileges:', error);
        alert('Failed to save permissions. Please try again.');
        this.saving = false;
      }
    });
  }
}
